let mutations = {
    loyaltypoints(state, data) {
      state.loyaltypoints = data
    }
  
  }
  export default mutations


// WEBPACK FOOTER //
// ./src/store/loyaltyPointStatement/mutations.js